export default __webpack_public_path__ + "static/media/logo-storyslab.6f3d7853.png";